analisa o
<template>
  <div class="users-tab">
    <!-- Modern Header -->
    <div class="tab-header">
      <div class="header-content">
        <div class="header-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        </div>
        <div>
          <h2>Gerenciamento de Usuários</h2>
          <p>Gerencie usuários, permissões e restrições</p>
        </div>
      </div>
      <div class="header-stats">
        <div class="stat-item">
          <span class="stat-value">{{ pagination?.total || 0 }}</span>
          <span class="stat-label">Total</span>
        </div>
      </div>
    </div>

    <!-- Search and Filters -->
    <div class="filters-section">
      <div class="search-bar">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="search-icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          v-model="filters.search"
          type="text"
          placeholder="Buscar por nome ou email..."
          class="search-input"
          @input="debounceSearch"
        />
        <button v-if="filters.search" @click="clearSearch" class="clear-btn">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div class="filter-groups">
        <div class="filter-group">
          <span class="filter-label">Função:</span>
          <div class="filter-buttons">
            <button
              v-for="role in ['all', 'admin', 'user']"
              :key="role"
              @click="setRoleFilter(role)"
              :class="['filter-btn', { active: filters.role === role }]"
            >
              <svg
                v-if="role === 'admin'"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                v-else-if="role === 'user'"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"
                />
              </svg>
              <span>{{
                role === "all"
                  ? "Todos"
                  : role === "admin"
                  ? "Admins"
                  : "Usuários"
              }}</span>
            </button>
          </div>
        </div>

        <div class="filter-group">
          <span class="filter-label">Status:</span>
          <div class="filter-buttons">
            <button
              v-for="banStatus in ['all', 'banned', 'unbanned']"
              :key="banStatus"
              @click="setBanFilter(banStatus)"
              :class="['filter-btn', { active: filters.banned === banStatus }]"
            >
              <svg
                v-if="banStatus === 'banned'"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                v-else-if="banStatus === 'unbanned'"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>{{
                banStatus === "all"
                  ? "Todos"
                  : banStatus === "banned"
                  ? "Banidos"
                  : "Ativos"
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Users Grid -->
    <div class="users-grid" v-if="!loading && users.length > 0">
      <div
        v-for="user in users"
        :key="user.id"
        :class="['user-card', { 'banned-user': isUserBanned(user) }]"
      >
        <!-- User Avatar & Info -->
        <div class="user-header">
          <div class="user-avatar-wrapper">
            <UserAvatar :user="user" size="md" />
            <div v-if="isUserBanned(user)" class="ban-indicator">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div v-if="isUserCommentBanned(user)" class="comment-ban-indicator">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
                />
                <path
                  d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
                />
              </svg>
            </div>
          </div>
          <div class="user-info">
            <h3 class="user-name">{{ user.username }}</h3>
            <p class="user-email">{{ user.email }}</p>
          </div>
        </div>

        <!-- User Details -->
        <div class="user-details">
          <div class="detail-row">
            <span class="detail-label">Função:</span>
            <span class="role-badge" :class="'role-' + user.role">
              <svg
                v-if="user.role === 'admin'"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clip-rule="evenodd"
                />
              </svg>
              {{ user.role === "admin" ? "Administrador" : "Usuário" }}
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Status:</span>
            <span v-if="isUserBanned(user)" class="status-badge banned">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                  clip-rule="evenodd"
                />
              </svg>
              Banido
            </span>
            <span v-else class="status-badge active">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clip-rule="evenodd"
                />
              </svg>
              Ativo
            </span>
          </div>

          <div v-if="isUserBanned(user)" class="detail-row">
            <span class="detail-label">Banido até:</span>
            <span class="detail-value">{{
              formatDate(user.banned_until)
            }}</span>
          </div>

          <div v-if="user.ban_reason" class="detail-row">
            <span class="detail-label">Motivo:</span>
            <span class="detail-value reason">{{ user.ban_reason }}</span>
          </div>

          <div v-if="isUserCommentBanned(user)" class="detail-row">
            <span class="detail-label">Comentários:</span>
            <span class="status-badge comment-banned">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
                />
              </svg>
              Restritos até {{ formatDate(user.comment_banned_until) }}
            </span>
          </div>

          <div class="detail-row">
            <span class="detail-label">Criado em:</span>
            <span class="detail-value">{{ formatDate(user.created_at) }}</span>
          </div>
        </div>

        <!-- Actions -->
        <div class="user-actions">
          <button
            v-if="!isUserBanned(user)"
            @click="openBanModal(user, 'user')"
            class="action-btn ban-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                clip-rule="evenodd"
              />
            </svg>
            <span>Banir Usuário</span>
          </button>
          <button
            v-else
            @click="openUnbanModal(user, 'user')"
            class="action-btn unban-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            <span>Desbanir</span>
          </button>

          <button
            v-if="!isUserCommentBanned(user)"
            @click="openBanModal(user, 'comment')"
            class="action-btn comment-ban-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
              />
            </svg>
            <span>Bloquear Comentários</span>
          </button>
          <button
            v-else
            @click="openUnbanModal(user, 'comment')"
            class="action-btn comment-unban-btn"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"
              />
              <path
                d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"
              />
            </svg>
            <span>Liberar Comentários</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-if="!loading && users.length === 0" class="empty-state">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
        />
      </svg>
      <h3>Nenhum usuário encontrado</h3>
      <p>Tente ajustar os filtros de busca</p>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>Carregando usuários...</p>
    </div>

    <!-- Pagination -->
    <div v-if="!loading && pagination" class="pagination-section">
      <button
        @click="prevPage"
        :disabled="pagination.page <= 1"
        class="page-btn"
      >
        ← Anterior
      </button>

      <span class="page-info">
        Página {{ pagination.page }} de
        {{ Math.ceil(pagination.total / pagination.limit) }} ({{
          pagination.total
        }}
        usuários)
      </span>

      <button
        @click="nextPage"
        :disabled="
          pagination.page >= Math.ceil(pagination.total / pagination.limit)
        "
        class="page-btn"
      >
        Próxima →
      </button>
    </div>

    <!-- Ban/Unban Modal -->
    <Teleport to="body">
      <transition name="modal-fade">
        <div v-if="modal.visible" class="modal-overlay" @click="closeModal">
          <div class="modal-container" @click.stop>
            <div class="modal-header">
              <div
                class="modal-icon"
                :class="modal.action === 'ban' ? 'ban-icon' : 'unban-icon'"
              >
                <svg
                  v-if="modal.action === 'ban'"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div class="modal-title-section">
                <h3 class="modal-title">
                  {{ getModalTitle() }}
                </h3>
                <p class="modal-subtitle">{{ modal.user?.username }}</p>
              </div>
              <button @click="closeModal" class="modal-close">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div class="modal-body">
              <!-- User Info Card -->
              <div class="user-preview-card">
                <div class="user-preview-avatar">
                  <img
                    v-if="getUserImageUrl(modal.user)"
                    :src="getUserImageUrl(modal.user)"
                    :alt="modal.user?.username"
                  />
                  <div v-else class="preview-avatar-default">
                    {{ modal.user?.username?.charAt(0)?.toUpperCase() }}
                  </div>
                </div>
                <div class="user-preview-info">
                  <h4>{{ modal.user?.username }}</h4>
                  <p>{{ modal.user?.email }}</p>
                  <span
                    class="preview-role-badge"
                    :class="'role-' + modal.user?.role"
                  >
                    {{
                      modal.user?.role === "admin" ? "Administrador" : "Usuário"
                    }}
                  </span>
                </div>
              </div>

              <!-- Action Message -->
              <div class="modal-message" :class="modal.action">
                <p v-if="modal.action === 'ban'">
                  {{
                    modal.type === "user"
                      ? "⚠️ Você está prestes a banir este usuário. Ele não poderá mais acessar o sistema durante o período especificado."
                      : "⚠️ Você está prestes a restringir os comentários deste usuário. Ele não poderá comentar durante o período especificado."
                  }}
                </p>
                <p v-else>
                  {{
                    modal.type === "user"
                      ? "✅ Confirma que deseja remover o banimento deste usuário? Ele voltará a ter acesso normal ao sistema."
                      : "✅ Confirma que deseja remover a restrição de comentários? O usuário poderá voltar a comentar."
                  }}
                </p>
              </div>

              <!-- Ban Form -->
              <div v-if="modal.action === 'ban'" class="ban-form">
                <div class="form-group">
                  <label class="form-label">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Motivo da
                    {{ modal.type === "user" ? "banimento" : "restrição" }} *
                  </label>
                  <textarea
                    v-model="banReason"
                    :placeholder="
                      modal.type === 'user'
                        ? 'Descreva o motivo do banimento...'
                        : 'Descreva o motivo da restrição...'
                    "
                    rows="4"
                    class="form-textarea"
                    :class="{ 'input-error': !banReason && showValidation }"
                  ></textarea>
                  <span
                    v-if="!banReason && showValidation"
                    class="error-message"
                  >
                    O motivo é obrigatório
                  </span>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Duração
                  </label>
                  <div class="duration-grid">
                    <button
                      v-for="option in durationOptions"
                      :key="option.value"
                      @click="banDays = option.value"
                      :class="[
                        'duration-btn',
                        { active: banDays === option.value },
                      ]"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <span>{{ option.label }}</span>
                    </button>
                  </div>
                </div>

                <div class="duration-preview">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  <span
                    >{{
                      modal.type === "user"
                        ? "Usuário banido"
                        : "Comentários restritos"
                    }}
                    até: <strong>{{ getPreviewDate() }}</strong></span
                  >
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button @click="closeModal" class="btn-secondary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>Cancelar</span>
              </button>
              <button
                @click="executeAction"
                :disabled="
                  (modal.action === 'ban' && !banReason) || processingAction
                "
                :class="[
                  'btn-primary',
                  modal.action === 'ban' ? 'btn-danger' : 'btn-success',
                  { 'opacity-75 cursor-not-allowed': processingAction },
                ]"
              >
                <!-- Spinner de carregamento -->
                <svg
                  v-if="processingAction"
                  class="animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <!-- Ícone de banimento -->
                <svg
                  v-else-if="modal.action === 'ban'"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <!-- Ícone de desbanimento -->
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span v-if="processingAction">Processando...</span>
                <span v-else>{{
                  modal.action === "ban"
                    ? "Confirmar " +
                      (modal.type === "user" ? "Banimento" : "Restrição")
                    : "Confirmar Remoção"
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>
<script>
import apiService from "@/services/api";
import { debounce } from "lodash";
import UserAvatar from "@/components/UserAvatar.vue";

export default {
  name: "UsersTab",
  components: {
    UserAvatar,
  },
  data() {
    return {
      users: [],
      loading: false,
      processingAction: false, // Novo: indicador de processamento
      pagination: null,
      filters: {
        search: "",
        role: "all",
        banned: "all",
      },
      modal: {
        visible: false,
        user: null,
        action: "",
        type: "",
      },
      banReason: "",
      banDays: 3,
      showValidation: false,
      debounceSearch: null,
      durationOptions: [
        { value: 1, label: "1 dia" },
        { value: 3, label: "3 dias" },
        { value: 7, label: "1 semana" },
        { value: 14, label: "2 semanas" },
        { value: 30, label: "1 mês" },
        { value: 90, label: "3 meses" },
        { value: 365, label: "1 ano" },
      ],
    };
  },
  mounted() {
    this.debounceSearch = debounce(this.loadUsers, 500);
    this.loadUsers();
  },
  methods: {
    getUserImageUrl(user) {
      if (!user?.profile_image_url) return null;

      const rawUrl = user.profile_image_url;
      // Se já for URL completa
      if (rawUrl.startsWith("http")) {
        return rawUrl;
      }
      // Se for URL relativa
      const apiBase =
        process.env.VUE_APP_API_URL || "http://localhost:3000/api";
      const baseUrl = apiBase.replace("/api", "");
      return baseUrl + rawUrl;
    },

    handleImageError(event) {
      event.target.style.display = "none";
      const parent = event.target.parentElement;
      const fallback = document.createElement("div");
      fallback.className = "user-avatar-default";
      fallback.textContent = event.target.alt.charAt(0).toUpperCase();
      parent.appendChild(fallback);
    },

    clearSearch() {
      this.filters.search = "";
      this.loadUsers();
    },

    getModalTitle() {
      if (this.modal.action === "ban") {
        return this.modal.type === "user"
          ? "Banir Usuário"
          : "Restringir Comentários";
      }
      return this.modal.type === "user"
        ? "Remover Banimento"
        : "Liberar Comentários";
    },

    getPreviewDate() {
      const date = new Date();
      date.setDate(date.getDate() + parseInt(this.banDays));
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async loadUsers() {
      this.loading = true;
      try {
        const params = {
          search: this.filters.search || undefined,
          role: this.filters.role === "all" ? undefined : this.filters.role,
          banned:
            this.filters.banned === "all" ? undefined : this.filters.banned,
          page: this.pagination?.page || 1,
          limit: 20,
        };

        const response = await apiService.get(
          "/api/handlers?module=admin&action=users",
          { params }
        );
        this.users = response.data.users;
        this.pagination = response.data.pagination;
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
        this.$toast?.error("Erro ao carregar usuários");
      } finally {
        this.loading = false;
      }
    },

    setRoleFilter(role) {
      this.filters.role = role;
      this.loadUsers();
    },

    setBanFilter(status) {
      this.filters.banned = status;
      this.loadUsers();
    },

    prevPage() {
      if (this.pagination && this.pagination.page > 1) {
        this.pagination.page--;
        this.loadUsers();
      }
    },

    nextPage() {
      if (
        this.pagination &&
        this.pagination.page <
          Math.ceil(this.pagination.total / this.pagination.limit)
      ) {
        this.pagination.page++;
        this.loadUsers();
      }
    },

    isUserBanned(user) {
      if (!user || !user.banned_until) return false;
      return new Date(user.banned_until) > new Date();
    },

    isUserCommentBanned(user) {
      if (!user || !user.comment_banned_until) return false;
      return new Date(user.comment_banned_until) > new Date();
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString("pt-BR");
    },

    openBanModal(user, type) {
      this.modal = {
        visible: true,
        user,
        action: "ban",
        type,
      };
      this.banReason = "";
      this.banDays = 3;
      this.showValidation = false;
    },

    openUnbanModal(user, type) {
      this.modal = {
        visible: true,
        user,
        action: "unban",
        type,
      };
      this.showValidation = false;
    },

    async executeAction() {
      if (!this.modal.user) return;

      if (this.modal.action === "ban" && !this.banReason) {
        this.showValidation = true;
        return;
      }

      // Ativar indicador de carregamento
      this.processingAction = true;

      try {
        const userId = this.modal.user.id;

        if (this.modal.action === "ban") {
          if (this.modal.type === "user") {
            const response = await apiService.post(`/api/handlers`, {
              reason: this.banReason,
              days: parseInt(this.banDays),
            }, {
              params: { module: "admin", action: "users-ban", userId },
            });

            console.log("✅ Resposta do banimento:", response);

            // Atualizar o usuário localmente
            const userIndex = this.users.findIndex(
              (u) => u.id === this.modal.user.id
            );
            if (userIndex !== -1) {
              const banUntil = new Date();
              banUntil.setDate(banUntil.getDate() + parseInt(this.banDays));
              // Vue 3: atualização direta
              this.users[userIndex] = {
                ...this.users[userIndex],
                banned_until: banUntil.toISOString(),
                ban_reason: this.banReason,
              };
            }
          } else {
            const response = await apiService.post(`/api/handlers`, {
              reason: this.banReason,
              days: parseInt(this.banDays),
            }, {
              params: { module: "admin", action: "users-ban-comments", userId },
            });

            console.log(
              "✅ Resposta da restrição de comentários:", response
            );

            // Atualizar o usuário localmente
            const userIndex = this.users.findIndex(
              (u) => u.id === this.modal.user.id
            );
            if (userIndex !== -1) {
              const banUntil = new Date();
              banUntil.setDate(banUntil.getDate() + parseInt(this.banDays));
              // Vue 3: atualização direta
              this.users[userIndex] = {
                ...this.users[userIndex],
                comment_banned_until: banUntil.toISOString(),
                comment_ban_reason: this.banReason,
              };
            }
          }

          // Mostrar toast de sucesso
          if (this.$toast) {
            this.$toast.success(
              this.modal.type === "user"
                ? "✅ Usuário banido com sucesso"
                : "✅ Comentários restringidos com sucesso"
            );
          }
        } else if (this.modal.action === "unban") {
          if (this.modal.type === "user") {
            const response = await apiService.post(`/api/handlers`, {}, {
              params: { module: "admin", action: "users-unban", userId },
            });

            console.log("✅ Resposta do desbanimento:", response);

            // Atualizar o usuário localmente
            const userIndex = this.users.findIndex(
              (u) => u.id === this.modal.user.id
            );
            if (userIndex !== -1) {
              // Vue 3: atualização direta
              this.users[userIndex] = {
                ...this.users[userIndex],
                banned_until: null,
                ban_reason: null,
              };
            }
          } else {
            const response = await apiService.post(`/api/handlers`, {}, {
              params: { module: "admin", action: "users-unban-comments", userId },
            });

            console.log(
              "✅ Resposta da liberação de comentários:", response
            );

            // Atualizar o usuário localmente
            const userIndex = this.users.findIndex(
              (u) => u.id === this.modal.user.id
            );
            if (userIndex !== -1) {
              // Vue 3: atualização direta
              this.users[userIndex] = {
                ...this.users[userIndex],
                comment_banned_until: null,
                comment_ban_reason: null,
              };
            }
          }

          // Mostrar toast de sucesso
          if (this.$toast) {
            this.$toast.success(
              this.modal.type === "user"
                ? "✅ Usuário desbanido com sucesso"
                : "✅ Comentários liberados com sucesso"
            );
          }
        }

        // Fechar modal
        this.closeModal();

        // Recarregar lista do servidor para garantir consistência
        await this.loadUsers();
      } catch (error) {
        console.error("❌ Erro ao executar ação:", error);

        // Mostrar erro detalhado
        const errorMessage =
          error.response?.data?.message || "Erro ao executar ação";

        if (this.$toast) {
          this.$toast.error(`❌ ${errorMessage}`);
        }
      } finally {
        // Desativar indicador de carregamento
        this.processingAction = false;
      }
    },

    closeModal() {
      this.modal.visible = false;
      this.modal.user = null;
      this.modal.action = "";
      this.modal.type = "";
      this.banReason = "";
      this.banDays = 3;
      this.showValidation = false;
      this.processingAction = false;
    },
  },
};
</script>

<style scoped>
/* Modern Users Tab Styles */
.users-tab {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.tab-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.header-icon {
  width: 64px;
  height: 64px;
  background: #3b82f6;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  transition: all 0.3s ease;
}

.header-icon:hover {
  background: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.header-icon svg {
  width: 32px;
  height: 32px;
  color: white;
}

.tab-header h2 {
  font-size: 1.875rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 0.25rem 0;
}

.tab-header p {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.header-stats {
  display: flex;
  gap: 2rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 1.5rem;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: white;
  border-color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.stat-value {
  font-size: 2rem;
  font-weight: 800;
  color: #3b82f6;
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.25rem;
}

/* Filters Section */
.filters-section {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
  margin-bottom: 2rem;
}

.search-bar {
  position: relative;
  margin-bottom: 1.5rem;
}

.search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #9ca3af;
}

.search-input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 3rem;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-size: 0.9375rem;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.search-input:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.clear-btn {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.5rem;
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.clear-btn:hover {
  background: #f3f4f6;
  color: #6b7280;
}

.clear-btn svg {
  width: 16px;
  height: 16px;
}

.filter-groups {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  min-width: 80px;
}

.filter-buttons {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.filter-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-btn svg {
  width: 16px;
  height: 16px;
}

.filter-btn:hover {
  background: white;
  border-color: #d1d5db;
  color: #374151;
}

.filter-btn.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.filter-btn.active:hover {
  background: #2563eb;
  border-color: #2563eb;
}

/* Users Grid */
.users-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.user-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 2px solid #e5e7eb;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  animation: slideIn 0.4s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.user-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  border-color: #3b82f6;
}

.user-card.banned-user {
  border-color: #ef4444;
  background: #fef2f2;
}

.user-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #f3f4f6;
}

.user-avatar-wrapper {
  position: relative;
  flex-shrink: 0;
}

.user-avatar-img,
.user-avatar-default {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.user-avatar-img {
  object-fit: cover;
  border: 3px solid #e5e7eb;
}

.user-avatar-default {
  background: #3b82f6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  border: 3px solid #e5e7eb;
}

.ban-indicator,
.comment-ban-indicator {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}

.ban-indicator {
  background: #ef4444;
}

.comment-ban-indicator {
  background: #f59e0b;
}

.ban-indicator svg,
.comment-ban-indicator svg {
  width: 12px;
  height: 12px;
  color: white;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.25rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* User Details */
.user-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.detail-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.detail-label {
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
}

.detail-value {
  font-size: 0.875rem;
  color: #374151;
  font-weight: 500;
  text-align: right;
}

.detail-value.reason {
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.role-badge,
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
}

.role-badge svg,
.status-badge svg {
  width: 14px;
  height: 14px;
}

.role-admin {
  background: #ef4444;
  color: white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.role-user {
  background: #10b981;
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.status-badge.active {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.banned {
  background: #fee2e2;
  color: #991b1b;
}

.status-badge.comment-banned {
  background: #fef3c7;
  color: #92400e;
}

/* User Actions */
.user-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn svg {
  width: 16px;
  height: 16px;
}

.ban-btn {
  background: #ef4444;
  color: white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.ban-btn:hover {
  background: #dc2626;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.unban-btn {
  background: #10b981;
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.unban-btn:hover {
  background: #059669;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.comment-ban-btn {
  background: #f59e0b;
  color: white;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

.comment-ban-btn:hover {
  background: #d97706;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
}

.comment-unban-btn {
  background: #3b82f6;
  color: white;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.comment-unban-btn:hover {
  background: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

/* Empty State */
.empty-state {
  background: white;
  border-radius: 16px;
  padding: 4rem 2rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 2px dashed #e5e7eb;
}

.empty-state svg {
  width: 64px;
  height: 64px;
  color: #d1d5db;
  margin-bottom: 1rem;
}

.empty-state h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #374151;
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  font-size: 0.9375rem;
  color: #9ca3af;
  margin: 0;
}

/* Loading State */
.loading-state {
  background: white;
  border-radius: 16px;
  padding: 4rem 2rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-state p {
  font-size: 1rem;
  color: #6b7280;
  margin: 0;
}

/* Pagination */
.pagination-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e7eb;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.page-btn:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.page-info {
  font-size: 0.9375rem;
  color: #6b7280;
  font-weight: 500;
}

/* Modal Styles */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .modal-container,
.modal-fade-leave-active .modal-container {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-fade-enter-from .modal-container {
  transform: scale(0.9) translateY(20px);
}

.modal-fade-leave-to .modal-container {
  transform: scale(0.95) translateY(-20px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  overflow-y: auto;
}

.modal-container {
  background: white;
  border-radius: 20px;
  max-width: 540px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  margin: auto;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 2rem;
  border-bottom: 1px solid #f3f4f6;
}

.modal-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modal-icon svg {
  width: 28px;
  height: 28px;
  color: white;
}

.modal-icon.ban-icon {
  background: #ef4444;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.modal-icon.unban-icon {
  background: #10b981;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.modal-title-section {
  flex: 1;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 0.25rem 0;
}

.modal-subtitle {
  font-size: 0.9375rem;
  color: #6b7280;
  margin: 0;
}

.modal-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f3f4f6;
  color: #6b7280;
}

.modal-close svg {
  width: 20px;
  height: 20px;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 2rem;
  max-height: calc(85vh - 200px);
}

/* User Preview Card */
.user-preview-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: #f9fafb;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  margin-bottom: 1.5rem;
}

.user-preview-avatar img,
.preview-avatar-default {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}

.user-preview-avatar img {
  object-fit: cover;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.preview-avatar-default {
  background: #3b82f6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.user-preview-info {
  flex: 1;
  min-width: 0;
}

.user-preview-info h4 {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 0.25rem 0;
}

.user-preview-info p {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0 0 0.5rem 0;
}

.preview-role-badge {
  display: inline-block;
  padding: 0.25rem 0.625rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Modal Message */
.modal-message {
  padding: 1rem 1.25rem;
  border-radius: 12px;
  border-left: 4px solid;
  margin-bottom: 1.5rem;
}

.modal-message.ban {
  background: #fef2f2;
  border-color: #ef4444;
}

.modal-message.unban {
  background: #d1fae5;
  border-color: #10b981;
}

.modal-message p {
  font-size: 0.9375rem;
  color: #374151;
  margin: 0;
  line-height: 1.6;
}

/* Ban Form */
.ban-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.form-label svg {
  width: 18px;
  height: 18px;
  color: #6b7280;
}

.form-textarea {
  width: 100%;
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.9375rem;
  font-family: inherit;
  resize: vertical;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.form-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-textarea.input-error {
  border-color: #ef4444;
  background: #fef2f2;
}

.error-message {
  font-size: 0.8125rem;
  color: #ef4444;
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.duration-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
  gap: 0.5rem;
}

.duration-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  padding: 0.875rem 0.5rem;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;
}

.duration-btn svg {
  width: 18px;
  height: 18px;
}

.duration-btn:hover {
  background: white;
  border-color: #d1d5db;
  color: #374151;
}

.duration-btn.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: white;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.duration-btn.active:hover {
  background: #2563eb;
}

.duration-preview {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: #dbeafe;
  border-radius: 10px;
  font-size: 0.875rem;
  color: #1e40af;
}

.duration-preview svg {
  width: 20px;
  height: 20px;
}

.duration-preview strong {
  font-weight: 700;
}

/* Modal Footer */
.modal-footer {
  display: flex;
  gap: 0.75rem;
  padding: 1.5rem 2rem;
  border-top: 1px solid #f3f4f6;
}

.btn-secondary,
.btn-primary {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary {
  background: #f3f4f6;
  color: #6b7280;
}

.btn-secondary:hover {
  background: #e5e7eb;
  color: #374151;
}

.btn-secondary svg {
  width: 18px;
  height: 18px;
}

.btn-primary {
  color: white;
}

.btn-primary svg {
  width: 18px;
  height: 18px;
}

/* Animação de spin para loading */
@keyframes spin-loading {
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin-loading 1s linear infinite;
}

.btn-danger {
  background: #ef4444;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}

.btn-danger:hover:not(:disabled) {
  background: #dc2626;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
  transform: translateY(-1px);
}

.btn-success {
  background: #10b981;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.btn-success:hover:not(:disabled) {
  background: #059669;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* Responsive */
@media (max-width: 1024px) {
  .users-grid {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }

  .header-stats {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .tab-header {
    flex-direction: column;
    gap: 1.5rem;
  }

  .header-stats {
    width: 100%;
    justify-content: center;
  }

  .users-grid {
    grid-template-columns: 1fr;
  }

  .filter-groups {
    flex-direction: column;
  }

  .filter-group {
    flex-direction: column;
    align-items: flex-start;
  }

  .pagination-section {
    flex-direction: column;
    gap: 1rem;
  }

  .modal-container {
    margin: 0;
  }

  .duration-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
